import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "prompt-block" }
const _hoisted_2 = { class: "prompt-inner" }
const _hoisted_3 = { class: "badge-wrapper" }
const _hoisted_4 = { class: "delete" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Badge = _resolveComponent("Badge")
  const _component_Input = _resolveComponent("Input")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Badge, {
          class: _normalizeClass(["role", {pointer: !$options.placeholder}]),
          brand: $props.role === 'developer',
          indigo: $props.role === 'assistant',
          success: $props.role === 'user',
          blue: $props.role === 'system',
          gray: $props.type === 'placeholder',
          onClick: _cache[0] || (_cache[0] = $event => (!$options.placeholder && $options.changeRole()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$utils.str.capitalize($options.placeholder ? $props.type : $props.role)), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class", "brand", "indigo", "success", "blue", "gray"])
      ]),
      ($options.placeholder)
        ? (_openBlock(), _createBlock(_component_Input, {
            key: 0,
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.value) = $event)),
            regexp: "^[a-zA-Z][a-zA-Z0-9_]*$",
            footer: false,
            required: "",
            class: "input",
            spellcheck: false
          }, null, 8 /* PROPS */, ["modelValue"]))
        : (_openBlock(), _createBlock(_component_TextArea, {
            key: 1,
            ref: "textarea",
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.value) = $event)),
            class: "textarea",
            autoresize: "",
            spellcheck: false
          }, null, 8 /* PROPS */, ["modelValue"])),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_IconAsButton, {
          icon: "trash-04",
          hoverable: "",
          size: "2rem",
          color: "--gray-500",
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('delete')))
        })
      ])
    ])), [
      [_directive_resize, () => _ctx.$throttle_200($options.onResize)]
    ])
  ]))
}